import { api } from "../../services/api";

export async function requestCreationCustomer(payload) {

    const response = await api.post('/customers.php', payload);

    const { data } = response;

    return data;
};

export async function validateRegisterToken(token) {

    const response = await api.get('/customers.php?validate_register_token=' + encodeURIComponent(token));

    const { data } = response;

    return data;
};

export async function getCustomerCatalog(slug) {

    const response = await api.get('/customers.php?slug=' + slug);

    const { data } = response;

    return data;
};

export async function updateCustomerProfile(payload) {
    const response = await api.patch('/customers.php', payload);
    return response.data;
}